/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-group[_ngcontent-%COMP%]{margin-top:18px}\n/*# sourceMappingURL=radio-buttons.component.css.map*/"];
export { styles as styles };
